export const noop = (): void => {
  return
}
export const asyncNoop = (): Promise<void> => Promise.resolve()
